module.exports = "img/flags/AI.56a842f.png";